export default {
    apiKey: "AIzaSyBLRq5T7eO0cNFLqum8JLhJeAlABlQ_b1k",
    authDomain: "valsalescalc.firebaseapp.com",
    databaseURL: "https://valsalescalc.firebaseio.com",
    projectId: "valsalescalc",
    storageBucket: "valsalescalc.appspot.com",
    messagingSenderId: "109106514255",
    appId: "1:109106514255:web:512f9a2d3aee124dbc9d3a"
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js